<template>
  <a-spin
    tip="Your document is being processed, do not leave this page!"
    :spinning="loading.pageLoading"
  >
  <a-config-provider :locale="getLocalConfigProvider()">
    <div class="wrapper">
      <div class="wrapper-header">
        <span>
          <a-icon type="wallet" class="margin-right-small" />
          Master Deposit Code
        </span>
        <a-button @click="handleReload" size="small" icon="reload"></a-button>
      </div>
      <div class="wrapper-body">
        <a-card>
          <a-row :gutter="12">
            <a-col :xs="{ span: 24 }" :lg="{ span: 5 }">
              <a-select
                placeholder="Select Type"
                v-model="searchtype"
                @change="moreSearch"
                class="width-full"
                allowClear
              >
                <a-select-option
                  v-for="item in gettypesearch"
                  :key="item.id_type_tax"
                  >{{ item.type_tax }}</a-select-option
                >
              </a-select>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
              <a-input-search v-model="search" placeholder="Quick Search" @change="moreSearch"
              :class="getScreen ? 'margin-top' : ''"
              />
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 3 }">
              <div style="width:100%;text-align:left">
                <a-button
                  type="primary"
                  icon="plus"
                  @click="handleShowModalProcess(null)"
                  :loading="loading.create"
                  :class="getScreen ? 'margin-top' : ''"
                >
                  Create
                </a-button>
                <a-button
                  hidden
                  :class="getScreen ? 'margin-top' : ''"
                  :icon="advancedsearch == 'display:none' ? 'down' : 'up'"
                  @click="handleshowMore"
                  >{{
                    advancedsearch == "display:none" ? "More" : "Less"
                  }}</a-button
                >
              </div>
            </a-col>
          </a-row>
          <a-row :style="advancedsearch" :gutter="16" class="margin-top">
            <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
              <!-- <div class="m-form-item-wrapper">
                <label>Create Date</label>
                <a-range-picker
                  :placeholder="['Start Date', 'End Date']"
                  v-model="taxDt"
                  :format="getDefaultDateFormat"
                  allowClear
                />
              </div> -->
            </a-col>
          </a-row>
        </a-card>
        <div>
            <a-table
              :rowKey="(record, index) => {
                  return index.toString();
                }
                "
              size="small"
              bordered
              :scroll="{ x: 950 }"
              :columns="columns.master"
              :dataSource="master"
              :pagination="pagination"
            >
              <template slot="nomor" slot-scope="text, data, index">
                <span>{{
                  (pagination.page - 1) * pagination.pageSize + index + 1
                }}</span>
              </template>
              <template slot="genSPT" slot-scope="data">
                <div style="width:100%;text-align:center">
                  {{ data.isspt == "1" ? "Yes" : "No" }}
                </div>
              </template>
              <template slot="trans_dt" slot-scope="text, data">
                <span>{{
                  data.trans_dt
                  ? moment(data.trans_dt).format(getDefaultDateFormat)
                  : "-"
                }}</span>
              </template>
              <template slot="kode" slot-scope="text, data">
                {{ data.kode_setoran_pajak }} / {{ data.type_tax }} 
              </template>
              <template slot="dtTLC" slot-scope="data">
                <div style="width:100%;text-align:center">
                {{ data.create_dt ? moment(data.create_dt).format("DD-MM-YYYY") : "-" }} / 
                {{ data.tlc_create }}
                </div>
              </template>
              <template slot="aksi1" slot-scope="text, data">
                <a-tooltip placement="bottom">
                  <template slot="title">
                    <span>Edit</span>
                  </template>
                  <a-button
                    @click="handleShowModalProcess(data)"
                    icon="edit"
                    type="primary"
                  ></a-button>
                </a-tooltip>
                &nbsp;
                <a-tooltip placement="bottom">
                  <template slot="title">
                    <span>Delete</span>
                  </template>
                  <a-button
                    @click="handleDeleteModalDeposit(data)"
                    icon="delete"
                    type="danger"
                    :loading="loading.delete && loading.modalProcessKey==data.id_setoran_pajak"
                    :disabled="data.used!='0'"
                  ></a-button>
                </a-tooltip>
              </template>
            </a-table>
        </div>
      </div>

      <a-modal
        v-model="modalProcess"
        v-if="modalProcess"
        @ok="handleModalProcess"
        @cancel="handleModalClose"
        :maskClosable="false"
        width="60%"
      >
        <span slot="title"> <a-icon type="reconciliation" />&nbsp;{{ modalData.jenis_transaksi_label }} </span>
        <a-form :form="formmodal">
          <a-row :gutter="16">
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-item label="Tax Type">
                <a-select
                  v-decorator="[
                      'tax_type',
                      {
                        rules: [{ required: true }],
                        initialValue: modalData.data.id_type_tax,
                      },
                    ]"
                  show-search
                  optionFilterProp="children"
                  :filterOption="filterOption"
                  @change="handleChangeTaxType"
                  :disabled="modalData.data.used != '0' && modalData.jenis_transaksi_label == 'Edit'"
                >
                  <a-select-option
                    v-for="item in listtax"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.text }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Deposit Code">
                <a-input v-decorator="['deposit_code',
                    { rules: [{ required: true }], initialValue: modalData.data.kode_setoran_pajak }]"
                    :disabled="modalData.data.used != '0' && modalData.jenis_transaksi_label == 'Edit'">
                </a-input> 
              </a-form-item>
              <a-form-item label="Deposit Type">
                <a-input v-decorator="['deposit_type',
                    { rules: [{ required: true }], initialValue: modalData.data.jenis_setoran }]">
                </a-input> 
              </a-form-item>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-item label="Generate SPT">
                <a-radio-group
                  buttonStyle="solid"
                  v-decorator="['genSPT', { rules: [{ required: true }], initialValue: modalData.data.isspt ? modalData.data.isspt : '1' }]"
                  @change="handleChangeVat"
                  ref="genSPT"
                  :disabled="modalData.data.used != '0' && modalData.jenis_transaksi_label == 'Edit'"
                >
                  <a-radio-button value="1">Yes</a-radio-button>
                  <a-radio-button value="0">No</a-radio-button>
                </a-radio-group>
              </a-form-item>
              <a-form-item label="Note">
                <a-textarea
                  :rows="5"
                  v-decorator="['note', { rules: [{ required: true }], initialValue: modalData.data.note }]"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <template slot="footer">
          <a-button key="save" type="primary" @click="handlesave" :loading="loading.save">
            Save
          </a-button>
        </template>
      </a-modal>
    </div>
    </a-config-provider>
  </a-spin>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import shortingArray from "@/mixins/MultishortArray";
import GlobalMethod from "@/mixins/GlobalMethod";
import _ from "lodash";

export default {
  name: "kode_setoran",
  mixins: [CurrencyFormat, HandleRoute, shortingArray, GlobalMethod],
  components: {},
  data() {
    const columns = {
      master: [
        {
          title: "#",
          key: "nomor",
          scopedSlots: { customRender: "nomor" },
          width: 50,
          align: "center",
        },
        {
          title: "Kode",
          key: "kode",
          scopedSlots: { customRender: "kode" },
          width: 210,
        },
        {
          title: "Jenis Setoran",
          key: "jns_setoran",
          dataIndex: "jenis_setoran",
          width: 200,
        },
        {
          title: "Note",
          key: "note",
          dataIndex: "note",
          width: 200,
        },
        {
          title: "Generate SPT",
          key: "genSPT",
          scopedSlots: { customRender: "genSPT" },
          width: 100,
        },
        {
          title: "Date / TLC",
          key: "dtTLC",
          scopedSlots: { customRender: "dtTLC" },
          width: 145,
        },
        {
          title: "Action",
          fixed: "right",
          align: "center",
          width: 100,
          scopedSlots: { customRender: "aksi1" },
        },
      ],
    };
    return {
      columns,
      loading: {
        pageLoading: false,
        save: false,
        delete: false,
        modalProcessKey: "",
      },
      master: [],
      master_origin: [],
      search: undefined,
      searchtype: undefined,
      advancedsearch: "display:none",
      dataEdit: [],
      modalProcess: false,
      modalData: {
        data: [],
      },
      pagination: {
        onChange: (page) => {
          this.pagination.page = page;
        },
        page: 1,
        pageSize: 10,
        size: "small",
      },
    }
  }, 
  beforeCreate() {
    this.formDepositEntry = this.$form.createForm(this);
    this.formmodal = this.$form.createForm(this);
  },
  mounted() {
    this.$store.dispatch("Fetch_TYPE_TAX");
    Event.$on("confirmMessageDelete", this.handledelete);
  },
  beforeDestroy() {
    Event.$off("confirmMessageDelete", this.handledelete);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getType_tax",
    ]),
    gettypesearch() {
      let arrayUniqueByKey = null;
      if (this.master_origin) {
        arrayUniqueByKey = [...new Map(this.master_origin.map(item =>
          [item['id_type_tax'], item])).values()];
      } 
      return arrayUniqueByKey;
    },
    listtax() {
      return _.filter(this.getType_tax, (el) => el.value !== "bea_masuk");
    },
  },
  created() {
    this.handleReload();
  },
  methods: {
    moment,
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    resetSearch() {
      this.search = undefined;
    },
    intoList(value) {
        this.master = value;
    },
    handleReload() {
      this.loading.pageLoading = true;
      this.asyncAxiosGet("kode_setoran", this.getAuth, {
        tlc: this.getAuth.username,
      })
        .then((res) => {
          this.master = res.data;
          this.master_origin = res.data;
          this.loading.pageLoading = false;
        })
        .catch((err) => {
          this.loading.pageLoading = false;
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
      this.resetSearch();
    },
    handleCreate(item) {
      this.$router.push({
        name: "list-create",
        params: { id: item.id, type: item.jenis_id },
      });
    },
    handleCreateAddendum(item) {
      this.$router.push({
        name: "createAddendum",
        params: { id: item.id, jenis_transaksi: item.jenis_transaksi },
      });
    },
    handleRelease(item) {
      this.$store
        .dispatch("releaseQueue", {
          auth: this.getAuth,
          id_ap: item.id_account_pay,
          id: item.id,
          jenis_transaksi: item.jenis_transaksi,
        })
        .then((res) => {
          this.$router.go();
          this.displayMessage("success-release");
        });
    },
    handleManifestRef(item) {
      const data = {
        rest_api:
          item.jenis_transaksi.toLowerCase() == "adendum"
            ? item.jenis_transaksi.toLowerCase()
            : "accountpay",
        id_manifest:
          item.jenis_transaksi.toLowerCase() == "adendum"
            ? item.id
            : item.id_account_pay,
        tlc: this.getAuth.username,
        user_pembuat: item.tlc_create,
      };

      this.handleView(data);
    },
    handleshowModalDeposit(item) {
      if (item.type == "tax_manual") {
        this.loading.modalDepositKey = item.id_tax_transaction;
        this.loading.modalDeposit = true;
        this.asyncAxiosGet("tax_transaction/edit", this.getAuth, {
          id_transaction: item.id_transaction,
        })
          .then((response) => {
            this.dataEdit = response;
            this.dataEdit.treekode_anggaran = response.peruntukan + ";" + response.sub_peruntukan + ";" + response.kode_anggaran;

            this.asyncAxiosGet("main/cost_center", this.getAuth, {
              tlc: this.getAuth.username,
            })
              .then((res) => {
                this.modalData.costcenterOri = res.cost_center;
                this.modalData.costcenter = res.cost_center;
                this.modalData.kode_anggaranOri = res.kode_anggaran;
                this.modalData.jenis_anggaran = res.jenis_anggaran;
                this.modalData.peruntukanOri = res.peruntukan;
                this.modalData.peruntukan = _.filter(res.peruntukan, (el) => el.anggaran_id == this.dataEdit.cost_center);
                this.modalData.sub_peruntukanOri = res.sub_peruntukan;
                this.modalData.sub_peruntukan = res.sub_peruntukan;

                this.asyncAxiosGet("tax_transaction/tree_anggaran", this.getAuth, {
                  anggaran_id: this.dataEdit.cost_center,
                  peruntukan_id: this.dataEdit.peruntukan,
                })
                  .then((res) => {
                    this.modalData.anggaran.tree = res.tree;
                    this.modalData.treeExpandedKeys = this.getParent(
                      this.modalData.anggaran.tree
                    );
                    this.modalData.anggaran.loadingtree = false;
                  })
                  .catch((err) => {
                    this.modalData.anggaran.loadingtree = false;
                    let responses = Object.assign({}, err.response.data);
                    this.displayMessageValue("error-other", responses.message);
                  });

                this.asyncAxiosGet(
                  this.urlgetObjec_setran_pajak,
                  this.getAuth,
                  { tlc: this.getAuth.username }
                )
                  .then((res2) => {
                    // this.modalData.listsetoranpajak = res2.setoran;
                    this.modalData.listsetoranpajakOri = res2.setoran;
                    this.modalData.listobjekpajak = res2.objek;

                    this.loading.modalDepositKey = "";
                    this.loading.modalDeposit = false;

                    if (
                      this.dataEdit.file_document_tax &&
                      this.dataEdit.file_document_tax != "No File Uploaded"
                    ) {
                      let typefile = this.fileTypeFromUrl(
                        this.dataEdit.file_document_tax
                      );
                      let file = this.dataURLtoFile(
                        typefile + this.dataEdit.file_document,
                        this.dataEdit.file_document_tax
                      );
                      file.uid = "vc-upload-1-1";
                      file.status = "done";
                      file.url =
                        this.$serviceUrl + this.dataEdit.path_document_tax;
                      this.modalData.fileList = [];
                      this.modalData.fileList.push(file);
                    } else {
                      this.modalData.fileList = [];
                    }
                    this.modalProcess = !this.modalProcess;
                  })
                  .catch((err) => {
                    this.loading.modalDepositKey = "";
                    this.loading.modalDeposit = false;
                    let responses = Object.assign({}, err.response.data);
                    this.displayMessageValue("error-other", responses.message);
                  });
              })
              .catch((err) => {
                this.loading.create = false;
                let responses = Object.assign({}, err.response.data);
                this.displayMessageValue("error-other", responses.message);
              });
          })
          .catch((err) => {
            this.loading.modalDepositKey = "";
            this.loading.modalDeposit = false;
            console.log(err);
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error-other", responses.message);
          });
      } else {
        this.loading.modalDepositKey = item.id_tax_transaction;
        this.loading.modalDeposit = true;
        this.dataEdit = item;

        this.asyncAxiosGet(this.urlgetObjec_setran_pajak, this.getAuth, {
          tlc: this.getAuth.username,
        })
          .then((res) => {
            //this.dataEdit.listsetoranpajak = res.setoran;
            this.modalData.listsetoranpajakOri = res.setoran;
            this.dataEdit.listobjekpajak = res.objek;

            if (item.document_tax && item.document_tax != "No File Uploaded") {
              this.asyncAxiosGet("main/base_64", this.getAuth, {
                path: item.document_path,
              })
                .then((response) => {
                  console.log(response);
                  let typefile = this.fileTypeFromUrl(item.document_tax);
                  let file = this.dataURLtoFile(
                    typefile + response.file_document_tax,
                    item.document_tax
                  );
                  file.uid = "vc-upload-1-1";
                  file.status = "done";
                  file.url = this.$serviceUrl + item.document_path;
                  this.dataEdit.fileList = [];
                  this.dataEdit.fileList.push(file);

                  this.loading.modalDeposit = false;
                  this.modalDepositEntry = !this.modalDepositEntry;
                })
                .catch((err) => {
                  console.log(err);
                  let responses = Object.assign({}, err.response.data);
                  this.displayMessageValue("error-other", responses.message);
                });
            } else {
              this.loading.modalDeposit = false;
              this.modalDepositEntry = !this.modalDepositEntry;
            }
          })
          .catch((err) => {
            this.loading.modalDeposit = false;
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error-other", responses.message);
          });
      }
    },
    handleManifest(item) {
      if (item.jenis_transaksi == "Adendum") {
        this.$router.push({
          name: "AddendumManifest",
          params: { id: item.id },
        });
      } else {
        if (this.isAkuntansi) {
          this.$router.push({
            name: "Spclaccount-pay-manifest",
            params: { id: item.id_account_pay },
          });
        } else {
          this.$router.push({
            name: "account-pay-manifest",
            params: { id: item.id_account_pay },
          });
        }
      }
    },
    handleManifestQueue(item) {
      if (item.jenis_transaksi == "Adendum") {
        this.$router.push({
          name: "AddendumManifest",
          params: { id: item.id },
        });
      } else {
        if (this.isAkuntansi) {
          this.$router.push({
            name: "Spclaccount-pay-manifest",
            params: { id: item.id_account_pay },
          });
        } else {
          this.$router.push({
            name: "account-pay-manifest",
            params: { id: item.id_account_pay },
          });
        }
      }
    },
    handleDocument(item) {
      this.$store
        .dispatch("getBuktiAP", { auth: this.getAuth, id: item.id })
        .then((res) => {
          this.buktiTransfer = res.data.data;
          this.modalDepositEntry = true;
        });
    },
    handleDownload(item) {
      window.open(this.$serviceUrl + item.url, "_blank");
    },
    handleClose() {
      this.modalDepositEntry = false;
    },
    handleshowMore() {
      if (this.advancedsearch == "display:none") {
        this.advancedsearch = "display:block";
      } else {
        this.advancedsearch = "display:none";
      }
    },

    handleRevisiAndClose(item) {
      const that = this;
      let title = "";
      let messageSukses = "";
      title = "Are you sure to revise this data";
      messageSukses = "Successfully revise data";

      this.$confirm({
        title: title,
        content: "Batal / OK?",
        onOk() {
          let promise = new Promise((resolve, reject) => {
            let data = {
              tlc: that.getAuth.username,
              aksi: item.button_aksi,
              id: item.id,
              jenis_transaksi: item.jenis_transaksi,
            };

            // try {
            //   resolve(data);
            // } catch {
            //   reject("error data");
            // }

            axios({
              method: "post",
              url: that.$serviceUrl + "account_pay/aksi_account_pay",
              data: data,
              auth: {
                username: that.getAuth.username,
                password: that.getAuth.password,
              },
              headers: {
                "Content-Type": "application/json",
                "X-API-KEY": that.getAuth.apikey,
              },
            })
              .then(({ data, status }) => {
                resolve(data);
              })
              .catch((err) => {
                reject(err);
              });
          }).catch(() => console.log("Oops errors!"));
          promise
            .then((value) => {
              that.displayMessageValue("success-other", messageSukses);
              that.handleReload();
            })
            .then((err) => {
              if (err) {
                let responses = Object.assign({}, err.response.data);
                that.displayMessageValue("error-other", responses.message);
              }
            });
          return promise;
        },
        onCancel() { },
      });
    },

    handleviewAttacment(item) {
      window.open(this.$serviceUrl + item.document_path);
    },
    handleShowModalProcess(data) {
      if (data) {
        this.modalData.jenis_transaksi_label = "Edit";
        this.modalData.data = data;
      } else {
        this.modalData.jenis_transaksi_label = "Create";
        this.modalData.data = [];
      }
      this.modalProcess = true;
    },
    handleModalProcess() {
      this.modalData.data = [];
      this.modalProcess = !this.modalProcess;
    },
    handleModalClose() {
      this.modalData.data = [];
      this.modalProcess = !this.modalProcess;
    },
    handleJenisAnggaran(e) {
      this.formmodal.setFieldsValue({
        cost_center: null,
        peruntukan: null,
        sub_peruntukan: null,
        kode_anggaran: null,
      });
      const filter = this.modalData.costcenterOri.filter(
        (obj) => obj.jns_anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );

      this.modalData.costcenter = filter;
      this.modalData.peruntukan = [];
      // this.anggaran.tree = [];
      // this.anggaran.treeModal = [];
      this.modalData.subPeruntukan = [];
    },
    handleCost(e) {
      this.$nextTick(function () {
        this.formmodal.setFieldsValue({
          peruntukan: null,
          sub_peruntukan: null,
          kode_anggaran: null,
        });
      });
      this.modalData.subPeruntukan = [];
      // this.modalData.anggaran.tree = [];
      // this.modalData.anggaran.treeModal = [];
      const peruntukan = this.modalData.peruntukanOri.filter(
        (obj) => obj.anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );
      this.modalData.peruntukan = peruntukan;
      // this.modalData.anggaran.anggaran_id = e;
      // this.modalData.data.cost_center_id = e;
    },
    handle_DetilTransaction(e) {
      let is_vat = this.formmodal.getFieldValue("is_vat");
      let params = _.filter(this.modalData.detil_transaction, (item) => item.id_dtl == e);
      this.modalData.dtl_value = this.formatCurrency('IDR', params[0].kredit);
      this.modalData.potensial_tax = params[0].potensial_tax ? params[0].potensial_tax : "0";
      this.modalData.reason_potensial = params[0].reason_potensial;
      this.handle_DetilTransaction2(e, is_vat);
    },
    handle_DetilTransaction2(e, isvat) {
      if (isvat == "0") {
        this.modalData.anggaran.loadingtree = true;
        let params = _.filter(this.modalData.detil_transaction, (item) => item.id_dtl == e);
        this.asyncAxiosGet("tax_verification/tree_anggaran", this.getAuth, {
          anggaran_id: params[0].anggaran_id,
          peruntukan_id: params[0].peruntukan_id,
        })
          .then((res) => {
            this.modalData.anggaran.tree = res.tree;
            this.modalData.treeExpandedKeys = this.getParent(
              this.modalData.anggaran.tree
            );
            this.modalData.anggaran.loadingtree = false;
          })
          .catch((err) => {
            this.modalData.anggaran.loadingtree = false;
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error-other", responses.message);
          });
      }
    },
    getParent(root) {
      let data = [];
      root.forEach((item) => {
        if (item.key) {
          data.push(item.key);
        }

        if (item.children.length > 0) {
          item.children.forEach((d) => {
            data.push(d.key);
          });
        }
      });
      return data;
    },
    handlechoiceCost(item) {
    },
    filterTreeNode(input, option) {
      //console.log(input, option)
      return (
        option.data.props.texttitle == undefined ||
        (option.data.props.texttitle ? option.data.props.texttitle : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0 ||
        (option.data.props.kode_anggaran ? option.data.props.kode_anggaran : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleChangeTaxType(e) {
      this.modalData.reftax_type = e;
      this.$nextTick(function () {
        this.formmodal.setFieldsValue({
          kode_setoran_pajak: null,
        });
      });
      this.filtertaxDeposit(e);
    },
    filtertaxDeposit(val) {
        this.modalData.listsetoranpajak = _.filter(this.modalData.listsetoranpajakOri,(item)=> item.id_type_tax==val);
    },
    preventEnterButton() {
      //antisipasi tekan enter karena bisa mengkacaukan validator minus dikomponennya
      this.$nextTick(function () {
        this.$refs.addMainBtn.$children[0].$el.focus();
      });
    },
    checkPrice(rule, value, callback) {
      if (value > 0) {
        callback();
        return;
      }
      callback("Price must greater than zero!");
    },
    beforeUploadAttachment(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.modalData.fileList = [];
        this.modalData.fileList.push(file);
        return false;
      }
    },
    handleRemoveAttachment() {
      this.modalData.fileList = [];
    },
    handleCancelVarification() {
      this.modalData.id_tax_verif_trans = "";
      this.modalData.potensial_tax = null;
      this.modalData.reason_potensial = null;
      this.modalData.anggaran.tree = null;
      this.modalData.submited = "0";
      this.modalData.is_vat = "1";
      this.$nextTick(function () {
        this.formmodal.setFieldsValue({
          id_dtl: null,
          tax_type: null,
          kode_setoran_pajak: null,
          objek_pajak: null,
          dpp_value: null,
          tax_value: null,
          file_document_tax: null,
          kode_anggaran: null,
        });
      });
      this.modalData.fileList = [];
    },
    taxDepositEntryUpdate() {
      this.handleReload();
    },
    handleDeleteModalDeposit(item) {
      this.confirmMessageValue("confirm-delete", item.id_setoran_pajak);
    },
    handledelete(id) {
      this.loading.delete = true;
      this.loading.modalProcessKey = id;

      this.asyncAxiosDelete(
        "kode_setoran",
        "application/json",
        this.getAuth,
        { id_setoran_pajak: id }
      )
        .then((response) => {
          this.loading.delete = false;
          this.loading.modalProcessKey = "";
          if (response.status && response.status == true) {
            this.displayMessageValue("success-other", response.message);
          } else {
            let responses = Object.assign({}, response);
            this.displayMessageValue("error-other", responses);
          }
          this.handleReload();
        })
        .catch((err) => {
          console.log(err);
          this.loading.delete = false;
          this.loading.modalProcessKey = "";
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
    },
    handlelinkNo(item) {
      item.id_manifest = item.id_transaksi;
      item.user_pembuat = item.tlc;
      this.handleView(item, true);
    },
    gettitletax(val) {
      let res = _.filter(this.getType_tax, (el) => el.value == val);
      return res.length > 0 ? res[0].text : "-";
    },
    viewFiledtl(tax_document_name, tax_document_path) {
      if (tax_document_path != '') {
        const url = this.$serviceUrl + tax_document_path;
        window.open(url, "_blank");
      }
    },
    editdtl(id) {
      this.loading.spinform = true;
      this.modalData.id_tax_verif_trans = id;
      let res = _.filter(this.verificationdtl_source, (el) => el.id == id);

      let params = _.filter(this.modalData.detil_transaction, (item) => item.id_dtl == res[0].id_dtl);
      this.modalData.dtl_value = this.formatCurrency('IDR', params[0].kredit);

      let setdata = new Promise((resolve, reject) => {
        this.handle_DetilTransaction(res[0].id_dtl);
        resolve(); // when successful
        reject();  // when error
      });
      setdata.then(() => {
        this.formmodal.setFieldsValue({
          kode_anggaran: res[0].id_anggaran
        });
      });
      this.dtlmodalchange();
      this.filtertaxDeposit(res[0].tax_type);
      this.$nextTick(function () {
        this.formmodal.setFieldsValue({
          id_dtl: res[0].id_dtl,
          reason_potensial: null,
          tax_type: res[0].tax_type,
          kode_setoran_pajak: res[0].kode_setoran_pajak,
          objek_pajak: res[0].objek_pajak,
          dpp_value: res[0].dpp_value,
          tax_value: res[0].tax_value,
          file_document_tax: null,
          is_vat: res[0].is_vat
        });
      });
      this.modalData.submited = res[0].submited;
      this.modalData.reftax_type = res[0].tax_type;
      if (res[0].is_vat == "0") {
        this.isvat = false;
        this.handle_DetilTransaction2(res[0].id_dtl, res[0].is_vat);
      }
      if(res[0].tax_document_name && res[0].tax_document_name!=''){
          this.loading.spinform=true;
          this.asyncAxiosGet("main/base_64", this.getAuth, {
            path: res[0].tax_document_path,
          })
            .then((response) => {
              let typefile = this.fileTypeFromUrl(res[0].tax_document_name);
              let file = this.dataURLtoFile(
                typefile + response.file_document_tax,
                res[0].tax_document_name
              );
              file.uid = "vc-upload-1-1";
              file.status = "done";
              file.url = this.$serviceUrl + res[0].tax_document_path;
              this.modalData.fileList = [];
              this.modalData.fileList.push(file);
              this.loading.spinform=false;
            })
            .catch((err) => {
              console.log(err);
              this.loading.spinform=false;
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error-other", responses.message);
            });
      }else{
        this.loading.spinform=false;
      }
    },
    dtlmodalchange() {
      for (let i = 0; i < this.verificationdtl_source.length; i++) {
        let index = _.findIndex(this.modalData.detil_transaction, (item) => item.id_dtl == this.verificationdtl_source[i].id_dtl);
        if(index>=0){
          this.modalData.detil_transaction[index].disabled = true;
        }
      }
    },
    handleChangeVat(val) {
      if (val.target.value=="1") {
        this.isvat = true;
        this.$nextTick(function () {
          this.formmodal.setFieldsValue({
            kode_anggaran: null,
          });
        });
      } else if(val.target.value == "0") {
        this.isvat = false;
        let id_dtl = this.formmodal.getFieldValue("id_dtl");
        if (id_dtl==undefined) {
          return
        }
        this.handle_DetilTransaction2(id_dtl, val.target.value);
      }
    },
    moreSearch: function () {
      let tempData = [];
      tempData = this.master_origin;

      if (tempData.length > 0 && this.searchtype) {
        tempData = tempData.filter(
          (obj) =>
          (obj.id_type_tax &&
            obj.id_type_tax == this.searchtype)
        );
      }
      
      if (tempData.length > 0 && this.search) {
        tempData = tempData.filter(
          (obj) =>
            (obj.jenis_setoran &&
              obj.jenis_setoran.toLowerCase().indexOf(this.search.toLowerCase()) >=
              0) ||
            (obj.kode_setoran_pajak &&
              obj.kode_setoran_pajak
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.note &&
              obj.note
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.tlc_create &&
              obj.tlc_create
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.create_dt &&
              this.moment(obj.create_dt)
                .format(this.getDefaultDateFormat)
                .toString()
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0)
        );
      }

      this.intoList(tempData);
    },
    handlesave() {
      this.formmodal.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        let pjk = _.filter(this.listtax, (el) => el.value == values.tax_type);
        
        let paramdata = null;
        if (this.modalData.jenis_transaksi_label == 'Edit') {
          paramdata = {
            id_setoran_pajak: this.modalData.data.id_setoran_pajak,
            type_pajak: pjk[0].text,
            type_pajak_value: pjk[0].value,
            kode_setoran: values.deposit_code,
            jenis_setoran: values.deposit_type,
            is_generate_spt: values.genSPT,
            note: values.note
          }
        } else {
          paramdata = {
            type_pajak: pjk[0].text,
            type_pajak_value: pjk[0].value,
            kode_setoran: values.deposit_code,
            jenis_setoran: values.deposit_type,
            is_generate_spt: values.genSPT,
            note: values.note
          }
        }


        this.loading.save = true;
        if (this.modalData.jenis_transaksi_label == 'Edit') {
          this.asyncAxiosPut("Kode_setoran", "application/json", this.getAuth, paramdata)
          .then((response) => {
            if (response.status && response.status == true) {
              this.displayMessageValue("success-other", response.message);
            } else {
              let responses = Object.assign({}, response);
              this.displayMessageValue("error-other", responses);
            }
            this.formmodal.resetFields();
            this.modalProcess = false;
            this.handleReload();
            this.loading.save = false;
          })
          .catch((err) => {
            console.log(err);
            this.loading.save = false;
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error-other", responses.message);
            this.loading.addVarification = false;
          });
        } else {
          this.asyncAxiosPost("Kode_setoran", "formdata", this.getAuth, data)
            .then((response) => {
              if (response.status && response.status == true) {
                this.displayMessageValue("success-other", response.message);
              } else {
                let responses = Object.assign({}, response);
                this.displayMessageValue("error-other", responses);
              }
              this.formmodal.resetFields();
              this.modalProcess = false;
              this.handleReload();
              this.loading.save = false;
            })
            .catch((err) => {
              console.log(err);
              this.loading.save = false;
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error-other", responses.message);
              this.loading.addVarification = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid darken(white, 10);
  &-header {
    height: 50px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border-bottom: 1px dashed darken(white, 10);
    padding: @padding;
  }
  &-body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.bordered {
  border: 1px solid darken(white, 10);
}

.custom-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.list-item {
  display: flex;
  align-items: flex-start;
}

.ant-select-dropdown-menu{
  width:500px;
  overflow: visible;
  display:block;
}
.ant-select-dropdown--single{
  width:500px;
  overflow: visible!important;
  display:block!important}
</style>

<style lang="less">
.custom-tabs {
  .ant {
    &-tabs-bar {
      margin-bottom: 0;
    }
    &-tabs-content {
      flex: 1;
    }
  }
}

.ant-table-thead > tr > th {
  text-align: center;
}

.lblTransactionType, .lbltaxable{
  border-top: solid 1px black;
  text-align: right;
  color: darken(@color-primary, 5)!important;
  font-size: x-small;
}

.lblnottaxable{
  border-top: solid 1px black;
  text-align: right;
  font-size: x-small;
}
</style>
